import { shallowEqual } from "react-redux";
import { useCarConfigSelector } from "../redux/store";
import { hasChargingSelector, hasPacksOrExtrasSelector } from "../utils/selectorUtils";
import useCarConfigServices from "./useCarConfigServices";

export const useServicesSectionVisibility = (): boolean => {
    const services = useCarConfigServices();
    // we can add more check here, if more tabs become active

    return !!services?.length;
};

export const usePacksAndExtrasSectionVisibility = (): boolean => {
    return useCarConfigSelector(hasPacksOrExtrasSelector, shallowEqual);
};

export const useChargingSectionVisibility = (): boolean => {
    return useCarConfigSelector(hasChargingSelector, shallowEqual);
};
